<template>
  <b-container class="header">
    <b-row>

      <!-- Блок с Лого -->
      <b-col>
        <b-link to="/">
          <img alt="RIS"
               src="../assets/logo_ru.png">
        </b-link>
      </b-col>

      <!-- Блок с контактной информацией -->
      <b-col class="font-weight-bold text-right info">
        Работа в сети ресторанов РИС в Сочи
        <!-- Возможно пусто тут будет всегда -->
      </b-col>

    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: 'Header',
    computed: {}
  }
</script>

<style scoped lang="scss">
  .header {
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>
